/**
 * This implementation is specific to this view
 * If re-use is necessary, recommend copying
 * and modifying to that specific use case
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@pattern-library/buttons';
import Modal from '@pattern-library/modal';

const propTypes = {

    /* global getDeviceFingerprint */

    /**
     * text to appear inside the button
     */
    buttonText: PropTypes.string.isRequired,

    /**
     * additional classnames to be applied to the button
     */
    buttonClassName: PropTypes.string.isRequired,

    /**
     * QA ID for the button
     */
    buttonQaId: PropTypes.string,

    /**
     * modal header text
     */
    modalHeader: PropTypes.string.isRequired,

    /**
     * modal body text
     */
    modalBody: PropTypes.string.isRequired,

    /**
     * form action url the modal will use to remove the device
     */
    modalActionUrl: PropTypes.string.isRequired,

    /**
     * required ID attribute for the modal
     */
    modalId: PropTypes.string.isRequired,

    /**
     * device name or phone number that will be removed
     */
    modalToBeRemoved: PropTypes.string.isRequired,

    /**
     * render form field specific to trusted device modal
     */
    useDeviceFingerprint: PropTypes.bool,

   /**
     * used to delete specific device if useDeviceFingerprint is true
     */
    fingerprintIdToDelete: PropTypes.string
};
const defaultProps = {
    useDeviceFingerprint: false,
    fingerprintIdToDelete: ''
};

class ButtonControlledModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalActive: false
        };
    }

    activateModal = () => {
        this.setState({ modalActive: true });
    };

    closeModal = () => {
        this.setState({ modalActive: false });
    };

    render() {
        const {
            buttonText,
            buttonClassName,
            buttonQaId,
            modalId,
            modalHeader,
            modalBody,
            modalActionUrl,
            modalToBeRemoved,
            useDeviceFingerprint,
            fingerprintIdToDelete
        } = this.props;          
        
        const deviceFingerprint = useDeviceFingerprint && typeof getDeviceFingerprint === 'function'
            ? JSON.stringify(getDeviceFingerprint())
            : '';
        
        const footerChildren = [
            <form key={0} action={modalActionUrl} method="post">
                <button
                    className="asc-btn asc-btn--tertiary"
                    type="button"
                    onClick={this.closeModal}
                >
                    Cancel
                </button>
                <button className="asc-btn asc-btn--tertiary asc-btn--danger" type="submit">
                    Delete
                </button>
                {deviceFingerprint && (
                    <input
                        type="hidden"
                        id="deviceFingerprint"
                        name="deviceFingerprint"
                        value={deviceFingerprint}
                    />
                )}
                {deviceFingerprint && (
                    <input
                        type="hidden"
                        id="fingerprintId"
                        name="fingerprintId"
                        value={fingerprintIdToDelete}
                    />
                )}
            </form>
        ];

        return (
            <React.Fragment>
                <Button
                    type="button"
                    text={buttonText}
                    className={buttonClassName}
                    clickHandler={this.activateModal}
                    qaId={buttonQaId}
                />
                <Modal
                    id={modalId}
                    isActive={this.state.modalActive}
                    closeModal={this.closeModal}
                    headerText={modalHeader}
                    hasFooter
                    hasFooterClose={false}
                    footerChildren={footerChildren}
                >
                    <p className="asc-secondary-text text--center">{modalBody}</p>
                    <h4 className="text--center">{modalToBeRemoved}</h4>
                </Modal>
            </React.Fragment>
        );
    }
}

ButtonControlledModal.propTypes = propTypes;
ButtonControlledModal.defaultProps = defaultProps;
export default ButtonControlledModal;
